
import {
    Spacer,
    Text
} from '@components/1-atoms';
import ListItem from '@components/2-molecules/ListItem';
import setTheme from '@lib/theme';
import React, { FC } from 'react';
import { View } from 'react-native';

import { PageProps } from '@lib/constants';

type Props = PageProps;

const theme = setTheme('light');

const ProductsServicesMenu: FC<Props> = ({ navigation, onDone, ...props }) => {

    return (
        <View>
            <ListItem
                /* right={ <Forward />} */
                sub={<Text small color={"#808080"}>{"Track invoiced items are those that you buy or sell as part of your operations."}</Text>}
                onPress={() => navigation?.navigate('NonInventoryProductServiceCreate', { ...props, onDone })}
            >
                <Text>Create a product or service</Text>
            </ListItem>
            <Spacer h={0.3} />

            <ListItem
                /* right={ <Forward />} */
                sub={<Text small color={"#808080"}>{"Invoiced and stock-monitored items are those that you buy or sell as part of your operations."}</Text>}
                onPress={() => navigation?.navigate('InventoryProductCreate', { ...props, onDone })}
            >
                <Text>Create an inventory product</Text>
            </ListItem>
            <Spacer h={0.3} />
        </View>
    );
};

export default ProductsServicesMenu;